import { isEmpty } from "lodash";

import getPageAndPageType from "./getPageAndPageType";

export default function getAnalyticsSourceProperties({
  includeReferrer,
  includeSourcePage,
  includeSourcePageType,
  referrer,
  pathname,
  params,
  searchParams,
}) {
  const urlSourcePage = searchParams.get("source_page");
  const urlSourcePageType = searchParams.get("source_page_type");
  const urlSourceName = searchParams.get("source_name");
  const urlSourceElement = searchParams.get("source_element");

  let sourceProperties = {};

  if (includeReferrer === false) {
    const { sourcePage, sourcePageType } = getPageAndPageType(pathname, params);

    if (includeSourcePage) {
      sourceProperties.sourcePage = sourcePage;
    }

    if (includeSourcePageType) {
      sourceProperties.sourcePageType = sourcePageType;
    }
  } else if (
    urlSourcePage ||
    urlSourcePageType ||
    urlSourceName ||
    urlSourceElement
  ) {
    sourceProperties = {
      sourcePage: urlSourcePage,
      sourcePageType: urlSourcePageType,
      sourceName: urlSourceName,
      sourceElement: urlSourceElement,
    };
  } else if (isEmpty(referrer)) {
    sourceProperties.sourcePage = "direct";
    sourceProperties.sourcePageType = "direct";
  } else {
    sourceProperties = referrer;
  }

  return sourceProperties;
}
